import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import { AppUserRoleSchema, AppUserSchema, DBAppUserRoleSchema, DBAppUserSchema } from './schemas';

export const AppUserCodecConfig: TransformerConfig<typeof AppUserSchema, typeof DBAppUserSchema> = {
  name: 'AppUser',
  clientSchema: AppUserSchema,
  dbSchema: DBAppUserSchema,
  transformers: [
    createTimestampTransformer<typeof AppUserSchema, typeof DBAppUserSchema>('createdAt'),
    createTimestampTransformer<typeof AppUserSchema, typeof DBAppUserSchema>('updatedAt', {
      nullable: true,
    }),
  ],
};

export const AppUserRoleCodecConfig: TransformerConfig<
  typeof AppUserRoleSchema,
  typeof DBAppUserRoleSchema
> = {
  name: 'AppUserRole',
  clientSchema: AppUserRoleSchema,
  dbSchema: DBAppUserRoleSchema,
  transformers: [
    createTimestampTransformer<typeof AppUserRoleSchema, typeof DBAppUserRoleSchema>('createdAt'),
  ],
};

export const encodeAppUserToDb = createEncodeToDbFn(AppUserCodecConfig);
export const decodeAppUserFromDb = createDecodeFromDbFn(AppUserCodecConfig);
export const encodeAppUserRoleToDb = createEncodeToDbFn(AppUserRoleCodecConfig);
export const decodeAppUserRoleFromDb = createDecodeFromDbFn(AppUserRoleCodecConfig);
